/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PromptTemplateEntry = {
  /**
   * The ID of the prompt template
   */
  id: string;
  /**
   * The kind of the prompt template
   */
  kind?: string | undefined;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  name: string;
};

/** @internal */
export const PromptTemplateEntry$inboundSchema: z.ZodMiniType<
  PromptTemplateEntry,
  unknown
> = z.object({
  id: z.string(),
  kind: z.optional(z.string()),
  name: z.string(),
});

export function promptTemplateEntryFromJSON(
  jsonString: string,
): SafeParseResult<PromptTemplateEntry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PromptTemplateEntry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PromptTemplateEntry' from JSON`,
  );
}
